import React, { useState } from 'react';
import { Button } from '@mui/material';
import SensitiveInfoDialog from '../../../../custom-widgets/dialogs/SensitiveInfoDialog';

const DIALOG_REGISTRY = {
    sensitiveInfo: {
        Component: SensitiveInfoDialog,
        getProps: (dialogProps, open, setOpen, user) => ({
            showOnlyDialog: true,
            open,
            setOpen,
            data: user,
            ...dialogProps,
        }),
    },
};

const DialogButton = ({ props = {}, dialogProps = {}, user, ...rest }) => {
    const [open, setOpen] = useState(false);

    const { label, dialog, ...buttonProps } = props;

    const dialogConfig = DIALOG_REGISTRY[dialog];

    if (!dialogConfig) {
        return null;
    }

    const { Component: DialogComponent, getProps } = dialogConfig;

    const resolvedDialogProps = getProps(dialogProps, open, setOpen, user);

    const handleClick = () => {
        setOpen(true);
    };

    return (
        <>
            <Button onClick={handleClick} {...buttonProps}>
                {label}
            </Button>
            <DialogComponent {...resolvedDialogProps} />
        </>
    );
};

export default DialogButton;
